// Handle gift products in cart
document.addEventListener('DOMContentLoaded', function() {
  console.log("🎁 Setting up cart gift handler...");
  
  // Fix for mobile scrolling when cart is open
  function fixCartScrolling() {
    // Check if cart drawer is open
    const cartDrawer = document.querySelector('.cart-drawer');
    if (!cartDrawer) return;
    
    // Monitor cart drawer open/close state
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
          const isHidden = cartDrawer.hasAttribute('hidden');
          
          if (!isHidden) {
            // Cart is open - prevent body scrolling
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          } else {
            // Cart is closed - allow body scrolling
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
          }
        }
      });
    });
    
    // Start observing cart drawer
    observer.observe(cartDrawer, { attributes: true });
    
    // Fix scrolling based on current state
    if (!cartDrawer.hasAttribute('hidden')) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  }
  
  // Run the scrolling fix
  fixCartScrolling();
  
  // Create template data view if it doesn't exist
  const createTemplateView = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log("Checking cart items for template:", cart.items.length);
        
        // Process each cart item
        cart.items.forEach(item => {
          const productId = item.product_id;
          const productHandle = item.handle;
          
          // Find cart item in DOM
          const cartItems = document.querySelectorAll('.cart-item');
          let cartItemElement = null;
          
          cartItems.forEach(element => {
            if (element.getAttribute('data-variant-id') == item.variant_id ||
                element.querySelector(`a[href*="/products/${productHandle}"]`)) {
              cartItemElement = element;
            }
          });
          
          if (!cartItemElement) {
            console.log("Could not find cart item element for:", productHandle);
            return;
          }
          
          // Direct check for known gift products by template
          if (productHandle.includes("dovana-auto") || 
              item.product_title.toLowerCase().includes("dovana")) {
            applyGiftStyles(cartItemElement);
            return;
          }
          
          // Fetch product page to check template
          fetch(`/products/${productHandle}`)
            .then(response => response.text())
            .then(html => {
              // Check if it's a gift product template
              const isGiftProduct = html.includes('template-suffix="dovana-auto"') || 
                                    html.includes('product--gift-item') ||
                                    html.includes('product.dovana-auto');
              
              console.log(`Product ${productHandle} - Is gift: ${isGiftProduct}`);
              
              if (isGiftProduct) {
                applyGiftStyles(cartItemElement);
              }
            })
            .catch(error => {
              console.error("Error checking product template:", error);
            });
        });
      })
      .catch(error => {
        console.error("Error fetching cart:", error);
      });
  };
  
  // Apply gift styling to cart item
  function applyGiftStyles(cartItem) {
    console.log("Applying gift styles to:", cartItem);
    
    // Remove any existing gift tags first to prevent duplication
    const existingTags = cartItem.querySelectorAll('.cart-item__gift-tag');
    existingTags.forEach(tag => tag.remove());
    
    // Mark as processed to avoid duplicates
    cartItem.dataset.giftProcessed = 'true';
    
    // Try different selector patterns to find quantity element
    const selectors = [
      '.cart-quantity', 
      'quantity-input',
      '.quantity',
      '.quantity-selector',
      '.cart-item__quantity',
      '.cart__quantity',
      'input[name="updates[]"]'
    ];
    
    let quantityElement = null;
    
    for (const selector of selectors) {
      const element = cartItem.querySelector(selector);
      if (element) {
        quantityElement = element;
        break;
      }
    }
    
    if (quantityElement) {
      console.log("Found quantity element:", quantityElement);
      
      // Hide quantity selector
      quantityElement.style.display = 'none';
      
      // Create gift tag
      const giftTag = document.createElement('div');
      giftTag.className = 'cart-item__gift-tag';
      giftTag.textContent = 'Dovana';
      giftTag.style.display = 'inline-block';
      giftTag.style.backgroundColor = '#ffebee';
      giftTag.style.color = '#c62828';
      giftTag.style.padding = '3px 8px';
      giftTag.style.borderRadius = '3px';
      giftTag.style.fontSize = '12px';
      giftTag.style.fontWeight = '600';
      giftTag.style.marginTop = '5px';
      giftTag.style.marginBottom = '5px';
      
      // Insert gift tag
      if (quantityElement.parentNode) {
        quantityElement.parentNode.insertBefore(giftTag, quantityElement);
      } else {
        cartItem.appendChild(giftTag);
      }
    } else {
      console.log("Could not find quantity element, adding gift tag to item directly");
      
      // Fallback: add gift tag directly to cart item
      const giftTag = document.createElement('div');
      giftTag.className = 'cart-item__gift-tag';
      giftTag.textContent = 'Dovana';
      giftTag.style.display = 'inline-block';
      giftTag.style.backgroundColor = '#ffebee';
      giftTag.style.color = '#c62828';
      giftTag.style.padding = '3px 8px';
      giftTag.style.borderRadius = '3px';
      giftTag.style.fontSize = '12px';
      giftTag.style.fontWeight = '600';
      giftTag.style.marginTop = '5px';
      giftTag.style.marginBottom = '5px';
      
      // Find a good place to add the tag (price, actions, or just append)
      const priceElement = cartItem.querySelector('.cart-item__price, .cart-item__totals, .price');
      if (priceElement) {
        priceElement.parentNode.insertBefore(giftTag, priceElement);
      } else {
        cartItem.appendChild(giftTag);
      }
    }
  }
  
  // Run the check on page load
  setTimeout(createTemplateView, 500);
  
  // Also run whenever the cart might change
  document.addEventListener('cart:updated', function() {
    setTimeout(createTemplateView, 500);
  });
  
  // Watch for DOM changes in the cart
  const cartObserver = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.addedNodes.length > 0) {
        shouldCheck = true;
        break;
      }
    }
    
    if (shouldCheck) {
      setTimeout(createTemplateView, 500);
    }
  });
  
  // Observe cart container
  const cartContainer = document.querySelector('.cart-drawer, .cart');
  if (cartContainer) {
    cartObserver.observe(cartContainer, { 
      childList: true,
      subtree: true
    });
  }
  
  // Also run on cart button clicks
  document.addEventListener('click', function(event) {
    if (event.target.closest('.cart-drawer, .cart, [data-cart-drawer-toggle]')) {
      setTimeout(createTemplateView, 500);
    }
  });
});